// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"259985a1","232":"a0a5b811","237":"c02c9337","357":"3c200d3f","526":"4ef9edc1","787":"1ed0c42c","872":"3bda2143"}[chunkId] + ".chunk.js";
};